<template>
  <Layout>
    <div style="width: 100%; margin-top: 55px">
      <q-card v-if="vehicles.length === 0 && !loading">
        <empty-value name="vehicle" style="background: #fff !important"></empty-value>
      </q-card>
      <div id="table-scroll" ref="tablev2" class="table-scroll">
        <q-btn
          v-if="vehicles.length > 0"
          class="glossy custom-item-icon-3 left-0"
          style="margin-left: -10px"
          @mousedown="shiftLeft()"
          @mouseup="shiftLeftEnd()"
          round
          color="primary"
          icon="fas fa-arrow-left"
        />
        <q-btn
          v-if="vehicles.length > 0"
          class="glossy custom-item-icon-3 right-0"
          @mouseup="shiftRightEnd()"
          @mousedown="shiftRight()"
          round
          color="primary"
          icon="fas fa-arrow-right"
        />
        <table id="main-table" class="main-table shadow-2" v-if="vehicles.length > 0">
          <draggable v-bind="dragOptions" @start="drag = true" @end="drag = false" v-model="columns" tag="thead">
            <transition-group class="head-tr" tag="tr" type="transition" :name="drag ? 'flip-list' : null">
              <th
                :style="visibleColumns.some(item => item.name === col.name) ? 'display:table-cell' : 'display:none'"
                style="cursor: all-scroll"
                v-for="col in columns"
                @click="sortTable(col.val)"
                :key="col.val"
                scope="col"
              >
                <div v-if="col.name !== 'SELECT'">
                  {{ col.name }}
                  <i
                    v-if="sort.name && col.val === sort.name"
                    :class="sort.count % 2 === 1 ? 'fas fa-arrow-down' : 'fas fa-arrow-up'"
                    style="font-size: 12px"
                  ></i>
                </div>
                <div
                  v-else
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div
                    @click="selectAll = !selectAll"
                    class="container-checkbox"
                    :style="selectAll ? 'background:#00466f;border:none;width:18px;height:18px' : ''"
                  >
                    <i class="fas fa-check" v-if="selectAll" style="color: #fff; font-size: 14px"></i>
                  </div>
                </div>
              </th>
            </transition-group>
          </draggable>
          <transition-group name="flip-list" tag="tbody">
            <tr class="hoverable-tr" v-for="item in vehicles" :key="item.id">
              <td
                @click="header.val !== 'actions' && header.val !== 'condition' ? selectionVehicle(item) : ''"
                :class="[visibleChecker(header.name)]"
                v-for="header in columns"
                :key="header.val"
                :style="selectionCss(item.id)"
              >
                <div
                  v-if="
                    header.val !== 'selection' &&
                      header.val !== 'tags' &&
                      header.val !== 'actions' &&
                      header.val !== 'condition' &&
                      header.val !== 'last_mileage_record' &&
                      header.val !== 'in_service_date' &&
                      header.val !== 'status'
                  "
                >
                  {{
                    typeof item[header.val] == 'object' && header.val !== 'tags'
                      ? item[header.val] && item[header.val].name
                        ? item[header.val].name
                        : '-'
                      : item[header.val]
                  }}
                </div>
                <div v-else-if="header.val === 'tags'" class="tag-table-container">
                  <div v-if="item[header.val].length === 0">-</div>
                  <div
                    v-else
                    :style="randomColorGenerator(tag.color, index)"
                    class="tag-item"
                    v-for="(tag, index) in item[header.val]"
                    :key="index"
                  >
                    {{ index < 2 ? tag.name[0] : `+${item[header.val].length - 2}` }}
                    <q-tooltip>{{ index < 2 ? tag.name : `+${item[header.val].length - 2} more manual` }}</q-tooltip>
                  </div>
                </div>
                <div v-else-if="header.val === 'actions'">
                  <div class="tag-actions">
                    <q-btn size="xs" color="negative" style="margin-right: 5px" round @click="remove(item)">
                      <q-tooltip>Delete</q-tooltip>
                      <q-icon color="white" name="fas fa-trash" size="12px" class="cursor-pointer"></q-icon>
                    </q-btn>
                    <q-btn size="xs" style="margin-right: 5px" color="positive" round @click="editFunc(item)">
                      <q-tooltip>Edit</q-tooltip>
                      <q-icon color="white" name="far fa-edit" size="12px" class="cursor-pointer"></q-icon>
                    </q-btn>
                  </div>
                </div>
                <div v-else-if="header.val === 'condition'">
                  <span v-if="item[header.val] === 'excellent'">Above</span>
                  <span v-if="item[header.val] === 'good'">Average</span>
                  <span v-if="item[header.val] === 'fair'">Below</span>
                  <q-menu style="width: 300px">
                    <q-list style="min-width: 100px">
                      <q-item
                        v-for="cond in conditions"
                        :key="cond.val"
                        @click="updateVehicleCond(item, cond)"
                        clickable
                        v-close-popup
                      >
                        <q-item-section>
                          <span :style="item[header.val] === cond.val ? 'color:#1976D2' : ''">{{ cond.name }}</span>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-menu>
                </div>
                <div v-else-if="header.val === 'last_mileage_record'">
                  {{ mmrSetter(item[header.val], item.condition) }}
                </div>
                <div style="width:100px" v-else-if="header.val === 'in_service_date'">
                  {{
                    item[header.val]
                      ? new Date(item[header.val]).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric'
                        })
                      : '-'
                  }}
                </div>
                <div v-else-if="header.val === 'status'">
                  {{ getLabelByValue(item.status) }}
                </div>
                <q-checkbox v-else v-model="selection" dense :val="item" />
              </td>
            </tr>
          </transition-group>
        </table>
      </div>
      <div class="loading-infinite" v-if="loading">
        <div>
          <q-spinner-facebook color="primary" size="40px" />
          <div class="text-grey-7">Loading</div>
        </div>
      </div>
    </div>
    <vehicle-tag @resetSelections="resetSelections($event)"></vehicle-tag>
    <vehicle-edit></vehicle-edit>
    <vehicle-confirm></vehicle-confirm>
    <vehicle-operation></vehicle-operation>
  </Layout>
</template>
<script>
import draggable from 'vuedraggable'
import Layout from '../components/Layout'
import Vehicle from '../components/Vehicle'
import VehicleTable from '../components/VehicleTable'
import VehicleOperation from '../components/VehicleOperation'
import VehicleEdit from '../components/VehicleEdit'
import EmptyValue from '../components/EmptyValue'
import Loading from '../components/Loading'
import axios from '../axios/index'
import VehicleConfirm from '../components/VehicleConfirm'
import VehicleTag from '../components/VehicleTag'
import {getLabelByValue} from "@/enums";

export default {
  components: {
    VehicleTag,
    VehicleEdit,
    VehicleOperation,
    VehicleConfirm,
    EmptyValue,
    Loading,
    Vehicle,
    Layout,
    VehicleTable,
    draggable
  },
  data() {
    return {
      rightInterval: null,
      leftInterval: null,
      conditions: [
        {
          name: 'Above',
          val: 'excellent'
        },
        {
          name: 'Average',
          val: 'good'
        },
        {
          name: 'Below',
          val: 'fair'
        }
      ],
      drag2: false,
      drag: false,
      sort: {
        name: '',
        count: 0
      },
      columns: [
        {
          name: 'SELECT',
          val: 'selection'
        },
        {
          name: 'ACTIONS',
          val: 'actions'
        },
        {
          name: 'UNIT',
          val: 'unit'
        },
        {
          name: 'VIN',
          val: 'vin'
        },
        {
          name: 'BRAND',
          val: 'brand'
        },
        {
          name: 'MODEL',
          val: 'model'
        },
        {
          name: 'MODEL YEAR',
          val: 'model_year'
        },
        {
          name: 'CLASS NAME',
          val: 'class_name'
        },
        {
          name: 'IN SERVICE DATE',
          val: 'in_service_date'
        },
        {
          name: 'LOCATION',
          val: 'location'
        },
        {
          name: 'CONDITION',
          val: 'condition'
        },
        {
          name: 'AUCTION VALUE',
          val: 'last_mileage_record'
        },
        {
          name: 'MANUAL SELECTION',
          val: 'tags'
        },
        {
          name: 'STATUS',
          val: 'status'
        }
      ],
      selection: []
    }
  },
  metaInfo() {
    return {
      title: 'Adjustment of Current Fleet information | FMS',
      meta: [
        {
          name: 'description',
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: 'Adjustment of Current Fleet information'
        },
        {
          property: 'og:title',
          content: 'Adjustment of Current Fleet information | FMS'
        },
        { property: 'og:site_name', content: 'FMS' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  async mounted() {
    this.$root.$on('tagUpdateCheckVehicles', ({ id, name, color }) => {
      for (const vehicle of this.vehicles) {
        const { tags } = vehicle
        const isExistTagOnVehicle = tags.filter(tag => tag.id === id)[0]
        const props = {
          name,
          color,
          vehicle_id: vehicle.id
        }
        if (isExistTagOnVehicle && isExistTagOnVehicle.id)
          this.$store.commit('vehicle/UPDATE_VEHICLE_EXISTS_TAG', {
            ...props,
            tag_id: isExistTagOnVehicle.id
          })
      }
    })
    this.$store.state.vehicle.vehicles.length === 0 ? await this.getVehicles() : ''
    this.$store.state.vehicle.groups.length === 0 ? await this.getVehicleGroups() : ''
    this.$store.state.tag.tags.length === 0 ? await this.getTags() : ''
  },
  created() {
    setTimeout(() => {
      document.querySelector('.scroll').addEventListener('scroll', this.onScroll)
    }, 1000)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    getLabelByValue,
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
    conditionPutter(condition) {
      this.condition = this.conditions.filter(item => item.val === condition)[0]
    },
    visibleChecker(name) {
      return this.visibleColumns.some(item => item.name === name) ? 'table-cell' : 'none-cell'
    },
    async updateVehicleCond(vehicle, cond) {
      const { id, unit, vin } = vehicle
      const body = {
        unit,
        vin,
        condition: cond.val
      }
      try {
        await axios.patch(`vehicle-condition/${id}`, { condition: cond.val })
        this.$store.commit('vehicle/UPDATE_VEHICLE_CONDITION', body)
        this.selection = []
      } catch (error) {
        console.log(error)
      }
    },
    resetSelections() {
      this.selection = []
    },
    tagger(vehicle) {
      this.tagOperation = true
      //this.selectedVehicle = vehicle;
      this.$store.dispatch('vehicle/SET_SELECTED_VEHICLE', vehicle)
    },
    async getTags() {
      try {
        const { data } = await axios.get('vehicle-tags')
        this.tags = data.data
      } catch (error) {}
    },
    selectionVehicle(vehicle) {
      const { id } = vehicle
      const index = this.selection.findIndex(item => item.id === id)
      index === -1 ? (this.selection = [...this.selection, vehicle]) : this.selection.splice(index, 1)
    },
    remove(val) {
      //this.selectedVehicle = val;
      this.$store.dispatch('vehicle/SET_SELECTED_VEHICLE', val)
      this.confirm = true
    },
    async editFunc(val) {
      const {
        data: { data }
      } = await axios.get(`vehicle/${val.id}`)
      this.$store.dispatch('vehicle/SET_SELECTED_VEHICLE', data)
      this.edit = true
    },
    sortTable(row) {
      if (row !== 'selection' && row !== 'tags') {
        this.sort.name === row ? this.sort.count++ : ''
        this.sort.name = row
        const order = this.sort.count % 2 === 0 ? 'asc' : 'desc'
        const deep = [...this.vehicles]
        const sorted = deep.sort(this.sortVehicles(row, order))
        this.vehicles = sorted
      }
    },
    selectionChecker(id) {
      const ids = this.selection.map(item => item.id)
      const veh = this.selection.filter(item => item.id === id)[0]
      if (ids.includes(id)) {
        if (veh && veh.finance && veh.finance.id) return 'mark-table'
        else return 'selected-finance'
      }
    },
    sortVehicles(key, order) {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0
        }

        var varA, varB
        if (typeof a[key] === 'string') {
          varA = a[key] ? a[key].toUpperCase() : ''
        } else if (typeof a[key] === 'object' && key !== 'last_mileage_record') {
          varA = a[key] && a[key].name ? a[key].name.toUpperCase() : a[key][a.condition] ? a[key][a.condition] : ''
        } else if (typeof a[key] === 'object' && key === 'last_mileage_record')
          varA = a[key]['market_values'][0][a.condition]
        else varA = a[key]

        if (typeof b[key] === 'string') {
          varB = b[key] ? b[key].toUpperCase() : ''
        } else if (typeof b[key] === 'object') {
          varB = b[key] && b[key].name ? b[key].name.toUpperCase() : b[key][b.condition] ? b[key][b.condition] : ''
        } else if (typeof a[key] === 'object' && key === 'last_mileage_record')
          varB = b[key]['market_values'][0][b.condition]
        else varB = b[key]

        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return order === 'desc' ? comparison * -1 : comparison
      }
    },
    async getVehicleGroups() {
      const { data } = await axios.get('vehicle-groups')
      this.groups = data.data
    },
    onScroll(e) {
      const obj = e.target
      if (obj.scrollTop >= obj.scrollHeight - obj.offsetHeight - 100) {
        if (this.vehicles.length !== 0 && !this.loading) {
          this.page++
          this.getVehicles()
        }
      }
    },
    async getLocations(companyId) {
      if (companyId) {
        try {
          const params = { company_id: companyId }
          const { data } = await axios.get(`locations`, { params })
          this.locations = data.data
        } catch (error) {
        } finally {
        }
      }
    },
    resetter() {
      this.page = 1
      this.lastPage = 100
      this.vehicles = []
      this.loading = true
      setTimeout(() => {
        this.getVehicles()
      }, 50)
    },
    async getVehicles() {
      if (this.page > this.lastPage && !this.loading) {
        return false
      }
      this.loading = true
      const { params } = this.queryBuilder()
      const { data } = await axios.get('/vehicles', { params })
      this.loading = false
      const { last } = data.data.pagination
      this.lastPage = last

      let deep = () => {
        if (this.page === 1) {
          return data.data.items.map(item => item)
        } else {
          let carbon = [...this.vehicles]
          let nextPage = data.data.items.map(item => item)
          return carbon.concat(nextPage)
        }
      }
      this.vehicles = deep()
    },
    queryBuilder() {
      const params = { page: this.page, per: 20 }
      if (this.companyFilter.id) params.company_id = this.companyFilter.id
      if (this.search) params.q = this.search
      if (this.tagQ.length > 0) params.tag_id = this.tagQ.map(item => item.id)
      if (this.statusQ.length > 0) params.statuses = this.statusQ.map(item => item.value)
      if (this.multiFilter.length > 0) params.location_id = this.multiFilter.map(item => item.id)
      return { params }
    }
  },
  computed: {
    selectionCss() {
      return id => {
        const isInclude = this.selection.filter(item => item.id === id)[0]
        const wFinance = this.vehicles.filter(item => item.id === id)[0]
        if (isInclude && isInclude.id) {
          if (isInclude.finance && isInclude.finance.id) return 'background: rgba(0, 0, 0, 0.12) !important'
          else return 'background:rgba(244, 67, 54,.5) !important;'
        } else {
          if (wFinance.finance && wFinance.finance.id) return 'background: #fff !important'
          else return 'background: rgba(244, 67, 54, 0.1) !important;'
        }
      }
    },
    mmrSetter() {
      return (val, condition) =>
        val && val.market_values[0]
          ? val.market_values[0][condition].toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD'
            })
          : 0
    },
    tagQ: {
      get() {
        return this.$store.state.vehicle.tagQ
      },
      set(val) {
        this.$store.commit('vehicle/SET_TAG_Q', val)
      }
    },
    statusQ: {
      get() {
        return this.$store.state.vehicle.statusQ
      },
      set(val) {
        this.$store.commit('vehicle/SET_STATUS_Q', val)
      }
    },
    randomColorGenerator() {
      return (color, index) => {
        if (index === 0 || index === 1) return `background:${color}`
        else if (index === 2) return 'background:#F2C037'
        else return 'display:none'
      }
    },
    tags: {
      get() {
        return this.$store.state.tag.tags
      },
      set(val) {
        this.$store.commit('tag/SET_TAGS', val)
      }
    },
    tagOperation: {
      get() {
        return this.$store.state.vehicle.tagOperation
      },
      set(val) {
        this.$store.commit('vehicle/SET_TAG_OPERATION', val)
      }
    },
    selectAll: {
      get() {
        return this.vehicles ? this.selection.length === this.vehicles.length : false
      },
      set(value) {
        var select = []
        const deep = [...this.vehicles]
        if (value) {
          deep.map(item => (select = [...select, item]))
        }
        this.selection = select
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    visibleColumns() {
      return this.$store.state.vehicle.visibleColumns
    },
    // selectedVehicle: {
    //   get() {
    //     return this.$store.state.vehicle.selectedVehicle;
    //   },
    //   set(val) {
    //     this.$store.commit("vehicle/SET_SELECTED_VEHICLE", val);
    //   },
    // },
    confirm: {
      get() {
        return this.$store.state.vehicle.confirm
      },
      set(val) {
        this.$store.commit('vehicle/SET_CONFIRM', val)
      }
    },
    operation: {
      get() {
        return this.$store.state.vehicle.operation
      },
      set(val) {
        this.$store.commit('vehicle/SET_VEHICLE_OPERATION', val)
      }
    },
    edit: {
      get() {
        return this.$store.state.vehicle.edit
      },
      set(val) {
        this.$store.commit('vehicle/SET_EDIT', val)
      }
    },
    groups: {
      get() {
        return this.$store.state.vehicle.groups
      },
      set(val) {
        this.$store.commit('vehicle/SET_GROUPS', val)
      }
    },
    multiFilter: {
      get() {
        return this.$store.state.vehicle.multiFilter
      },
      set(val) {
        this.$store.commit('vehicle/SET_MULTI_FILTER', val)
      }
    },
    locationFilter: {
      get() {
        return this.$store.state.vehicle.locationFilter
      },
      set(val) {
        this.$store.commit('vehicle/SET_LOCATION_FILTER', val)
      }
    },
    lastPage: {
      get() {
        return this.$store.state.vehicle.lastPage
      },
      set(val) {
        this.$store.commit('vehicle/SET_LAST_PAGE', val)
      }
    },
    page: {
      get() {
        return this.$store.state.vehicle.page
      },
      set(val) {
        this.$store.commit('vehicle/SET_PAGE', val)
      }
    },
    loading: {
      get() {
        return this.$store.state.vehicle.loading
      },
      set(val) {
        this.$store.commit('vehicle/SET_LOADING', val)
      }
    },
    vehicles: {
      get() {
        return this.$store.state.vehicle.vehicles
      },
      set(val) {
        this.$store.commit('vehicle/SET_VEHICLES', val)
      }
    },
    locations: {
      get() {
        return this.$store.state.vehicle.locations
      },
      set(val) {
        this.$store.commit('vehicle/SET_LOCATIONS', val)
      }
    },
    companyFilter: {
      get() {
        return this.$store.state.vehicle.companyFilter
      },
      set(val) {
        this.$store.commit('vehicle/SET_COMPANY_FILTER', val)
      }
    },
    gridType() {
      return this.$store.state.vehicle.grid
    },
    search() {
      return this.$store.state.vehicle.search
    }
  },
  watch: {
    tagQ: {
      deep: true,
      handler(n, o) {
        this.resetter()
      }
    },
    statusQ: {
      deep: true,
      handler(n, o) {
        this.resetter()
      }
    },
    selection: {
      deep: true,
      immediate: true,
      handler(n, o) {
        this.$store.commit('vehicle/SET_SELECTED_VEHICLES', n)
      }
    },
    search(n, o) {
      window.scrollTo(0, 0)
      this.resetter()
    },
    companyFilter: {
      deep: true,
      handler(n, o) {
        window.scrollTo(0, 0)
        this.multiFilter = []
        n && n.id ? this.getLocations(n.id) : ''
        this.resetter()
      }
    },
    multiFilter(n, o) {
      window.scrollTo(0, 0)
      if (this.companyFilter.id) {
        this.resetter()
      }
    }
  }
}
</script>

<style lang="scss">
.custom-item-icon-3 {
  z-index: 999 !important;
  position: fixed !important;
  top: 60% !important;
}
.right-0 {
  right: 0;
}
.table-cell {
  display: table-cell;
}
.none-cell {
  display: none;
}
.selected-finance {
  background: rgba(244, 67, 54, 0.5) !important;
}
.no-finance {
  background: rgba(244, 67, 54, 0.1) !important;
}
.tag-table-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  .tag-item {
    margin-right: -5px;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 50%;
  }
}
.mark-table {
  background: rgba(0, 0, 0, 0.12) !important;
}
.flip-list-move {
  transition: transform 500ms;
}
.hoverable-tr {
  &:hover {
    td {
      transition: 500ms all;
      background: #f7f7f7;
    }
  }
}
.table-scroll {
  position: relative;
  z-index: 1;
  overflow: auto;
}
.table-scroll table {
  width: 100%;
  min-width: 1266px;
  border-collapse: separate;
  border-spacing: 0;
}
.table-wrap {
  position: relative;
}
.table-scroll {
  th {
    align-items: center;
    padding: 15px 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
  }
  td {
    padding: 15px 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
    cursor: pointer;
  }
}
@media only screen and (max-width: 600px) {
  .table-scroll th,
  .table-scroll td {
    padding: 15px 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: left;
  }
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.container-checkbox {
  width: 18px;
  cursor: pointer;
  height: 18px;
  text-align: center;
  border: 2px solid rgba(0, 0, 0, 0.54);
}
</style>
